import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';

import isEqual from 'lodash/isEqual';

import SvgIcon from 'Components/svg/SvgIcon';
import UserIcon from 'Components/common/UserIconComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

import rawToReact from 'Utils/bbcode/RawToReact';

import { hideReplyModal, displayNotification } from 'Actions/UiActions';
import {
	currentUser, topicForumId, topicTitle,
	messageTitle, messageContent, replyQuote,
	postSelected
} from 'Actions/ContextInfoActions';
import { deleteAttachment, setAttachmentsHash, updateEditingPostAttachments } from 'Actions/AttachmentsActions';
import { sendReply } from 'Actions/ReplyActions';
import { trackGAEvent } from 'Actions/adsActions';
import { setGlobalNotification, getFetchConfig } from 'Actions/GlobalMetaActions';

import ImageUploader from 'Utils/imageUploader';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import TextareaAutosize from 'react-textarea-autosize'

export class ReplyModalComponent extends Component {
	constructor(props){
		super(props);
		this.state = {
			title: '',
			subject: '',
			message: '',
			reason: '',
			uservalues: []

		};
		this.uploader = new ImageUploader( this.props.dispatch, this.doSetAttachmentsHash );
		this.selectLoading = false;
	}

	shouldComponentUpdate( nextProps, nextState ) {
		return (
			nextProps.isOpen !== this.props.isOpen ||
			nextProps.loading !== this.props.loading ||
			nextProps.responseHash !== this.props.responseHash ||
			nextProps.attachmentLoading !== this.props.attachmentLoading ||
			!isEqual( nextProps.attachments, this.props.attachments ) ||
			!isEqual( nextProps.options, this.props.options ) ||
			!isEqual( nextState, this.state )
		);
	}

	componentWillReceiveProps( nextProps ) {
		if( nextProps.isOpen !== this.props.isOpen ) {
			if( nextProps.isOpen ) {
				// Update state
				this._refreshState( nextProps );

			} else {
				// reset state if we close it
				this.setState( {
					title: '',
					subject: '',
					message: '',
					reason: '',
					uservalues: []
				} );
			}
		}
	}

	componentDidUpdate( prevProps ) {
		if( prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen ) {
			// using pushState to avoid popstate to be triggered
			history.pushState( { topifyExtra: true, type: 'replyModal' }, '', window.location );
		}
	}

	_refreshState( nextProps ) {
		let newState = {};

		if( nextProps.options && nextProps.options.user && this.state.uservalues.length === 0 ) {
			newState = {
				uservalues: [ {
					userid: nextProps.options.user.id,
					username: ( nextProps.options.user.userName || nextProps.options.user.username )
				} ]
			}
		}

		// Get default state values per type and set other settings
		switch( nextProps.options.type ) {
			case 'editPost':
				// Get current attachments when editing
				this.props.dispatch( updateEditingPostAttachments() );
				newState.message = this._messageContent( nextProps );
				break;

			case 'replyQuoting':
			case 'replyPost':
				newState.title = this.props.dispatch( topicTitle(nextProps.options.id) );
				newState.message = this._messageContent( nextProps );
				break;

			case 'replyMessageQuoting':
			case 'replyMessage':
				newState.subject = `Re: ${this.props.dispatch( messageTitle(nextProps.options.id) ).replace(/Re:\s*/, '')}`;
				newState.message = this._messageContent( nextProps );
				break;
		}

		// Save the new state
		this.setState( newState );
	}

	get currentUser(){
		return this.props.dispatch( currentUser() );
	}

	get type() {
		return this.props.options.type;
	}

	get data() {
		let data, sendTo;
		switch( this.type ) {
			case 'newTopic':
				return {
					type: 'topic',
					forumid: this.props.options.id,
					title: encodeURIComponent( this.state.title ),
					message: encodeURIComponent( this.state.message ),
					...this.props.responseHash
				};

			case 'replyPost':
			case 'replyQuoting':
				data = {
					type: 'reply',
					forumid: this.props.dispatch( topicForumId( this.props.options.id ) ),
					topic: this.props.options.id,
					message: encodeURIComponent( this.state.message ),
					...this.props.responseHash
				};
				let oldTitle = this.props.dispatch( topicTitle( this.props.options.id ) );
					if( oldTitle !== this.state.title ) {
						data.title = encodeURIComponent( this.state.title );
					}

				return data;

			case 'editPost':
				let reasonValue = this.state.reason;
				data = {
					type: 'edit',
					relpostid: parseInt(this.props.dispatch( postSelected() )),
					message: encodeURIComponent( this.state.message ),
					...this.props.responseHash
				};

				if (reasonValue === '') {
					return data;
				} else {
					return {
						...data,
						reason: reasonValue
					};
				}

			case 'newMessage':
				sendTo = this.state.uservalues.map( ( t ) => t.userid ).join( ',' );
				return {
					type: 'pm',
					to: sendTo,
					message: encodeURIComponent( this.state.message ),
					title: encodeURIComponent( this.state.subject )
				};

			case 'replyMessageQuoting':
			case 'replyMessage':
				sendTo = this.state.uservalues.map( ( t ) => t.userid ).join( ',' );
				return {
					type: 'pm',
					to: sendTo,
					reply: this.props.options.id,
					title: encodeURIComponent( this.state.subject ),
					message: encodeURIComponent( this.state.message )
				};

			default:
				return {};
		}
	}

	get attachmentsData() {
		switch(this.type) {
			case 'newTopic':
				return {
					type: 'upload',
					forumid: this.props.options.id,
					uid: this.currentUser.id,
					...this.props.responseHash
				};

			case 'replyPost':
			case 'replyQuoting':
				return {
					type: 'upload',
					topic: this.props.options.id,
					uid: this.currentUser.id,
					...this.props.responseHash
				};

			case 'editPost':
				return {
					type: 'upload',
					post: parseInt( this.props.dispatch( postSelected() ) ),
					uid: this.currentUser.id,
					...this.props.responseHash
				};

			default:
				return {};
		}
	}

	get removeAttachmentData(){
		switch( this.type ) {
			case 'editPost':
				return {
					type: 'deleteattachment',
					uid: this.currentUser.id,
					editpost: parseInt( this.props.dispatch( postSelected() ) ),
					...this.props.responseHash
				};

			default:
				return {
					type: 'deleteattachment',
					uid: this.currentUser.id,
					...this.props.responseHash
				};
		}
	}

	sendMessage = () => {
		if( this.props.attachmentLoading ) {
			displayNotification( 'warning', 'please wait for attachment to load and try again' );
		} else {
			this.props.dispatch( sendReply( this.currentUser, this.data ) );
		}
	};

	attachImage = () => {
		const postLimit = parseInt( this.props.ustate.perms.limitPostAttachments );

		if( this.props.attachmentLoading ) {
			displayNotification( 'warning', 'please wait for attachment to load and try again' );
		} else {
			if( postLimit === -1 || this.props.attachments.length < postLimit ) {
				document.querySelector('#imagePicker').click();
			} else {
				displayNotification( 'warning', 'attachment limit reached' );
			}
		}
	};

	uploadFiles = ( event ) => {
		this.uploader.processFiles( event.target.files, this.attachmentsData );
		document.querySelector('#imagePicker').value = null;
	};

	hideThisReplyModal = () => {
		this.setState( { value: [] } );
		this.props.dispatch( goBack() );
		this.props.dispatch( hideReplyModal() );

		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'replyToBack', 'uiAction', 'header') );
	};

	getUsernames = (input) => {
		const url = this.props.url,
			config = this.props.dispatch( getFetchConfig( true ) );

		let username = typeof input === 'object' && input.username ? input.username : input;
		this.selectLoading = true;

		return fetch(`${url}?v=3.0&ajax=1&object=name_suggest&req=get&name=${username}`, config)
			.then((response) => {
				if (!response.ok) {
					setGlobalNotification( dispatch, {}, response );
				} else {
					return response.json();
				}
			})
			.then( json => {
				this.selectLoading = false;
				return { options: json.names };
			});
	};

	doSetAttachmentsHash = ( hash ) => {
		this.props.dispatch( setAttachmentsHash(hash) );
	};

	_messageContent( props ) {
		switch( props.options.type ) {
			case 'replyQuoting':
				return this.props.dispatch( replyQuote() );

			case 'editPost':
				return this.props.dispatch( messageContent() );

			case 'replyMessageQuoting':
				return this.props.dispatch( replyQuote( [ parseInt( props.options.id ) ] ) );

			default:
				return '';
		}
	}

	title() {
		switch(this.type) {
			case 'replyQuoting':
			case 'replyPost':
				return 'Post Reply';

			case 'newTopic':
				return 'New Topic';

			case 'newMessage':
				return 'Create Message';

			case 'replyMessageQuoting':
			case 'replyMessage':
				return 'Message Reply';

			case 'editPost':
				return 'Edit Post';

			default:
				return '';
		}
	}

	handleInputChange = ( event ) => {
		const target = event.target;
		const value = target.value;
		const name = target.name;

		this.setState( { [name]: value } );
	};

	handleSelectChange = ( value ) => {
		this.setState( { uservalues: value } );
	};

	recipients() {
		return(
			<Select.Async
				multi={ true }
				matchProp="label"
				valueKey="userid"
				labelKey="username"
				placeholder='To:'
				value={ this.state.uservalues }
				loadOptions={ this.getUsernames }
				isLoading={ this.selectLoading }
				autoload={ false }
				minimumInput={ 1 }
				backspaceRemoves={ true }
				onChange={ this.handleSelectChange }
			/>
		);
	}

	deleteImage( id ) {
		document.getElementById( `attachment_${ id }` ).classList.add( 'removing' );
		this.props.dispatch( deleteAttachment( {
			...this.removeAttachmentData,
			delete: id
		} ) );
	}

	actionButtons(){
		switch(this.type){
			case 'newTopic':
			case 'replyQuoting':
			case 'replyPost':
			case 'editPost':
				return(
					<div className="buttons-container" >
						<div className="buttons" onClick={ this.attachImage }>
							<SvgIcon icon="attach_file" size="24px" />
							<input type="file" id="imagePicker" name="file"
								accept="image/png, image/jpeg, image/jpg, image/gif" style={ { display: 'none' } }
								onChange={ this.uploadFiles }
								multiple={ false } />
						</div>
						<div className="buttons" onClick={ this.sendMessage }>
							<SvgIcon icon="send" size="24px" />
						</div>
					</div>
				);

			default:
				return(
					<div className="buttons-container" >
						<div className="buttons" onClick={ this.sendMessage }>
							<SvgIcon icon="send" size="24px" />
						</div>
					</div>
				);
		}
	}

	images() {
		let klazz = (this.props.attachmentLoading === true ) ? '' : 'hidden';
		return this.props.attachments.map((attachment)=>{
			return (
				<li key={attachment.id} id={ `attachment_${ attachment.id }`} className="attachment">
					<span className='remove' onClick={ () => { this.deleteImage( attachment.id ) } }>X</span>
					<img src={attachment.url}  alt="" style={{maxWidth: '140px'}}/>
				</li>
			);
		}).concat(<li key='999' className={`${klazz} loader`}><LoaderCss style={{width: '140px', height: '90px'}} /></li>);
	}

	content() {
		switch(this.type) {
			case 'newTopic':
				let forumTitle = this.props.meta.path ? this.props.meta.path[ 0 ].title : '';
				return (
					<div className="reply-modal">
						<UserIcon user={ this.currentUser } layout="nostatus" className="user-info" noAction={ true } />
						<div className="field">
							<span>New topic in: <em>{ rawToReact( forumTitle ) }</em></span>
						</div>
						<div className="field input">
							<label htmlFor='replyTitle' className="field-label">
								<input name="title" onChange={ this.handleInputChange } type="text" placeholder='Title' value={ this.state.title } />
							</label>
						</div>
						<div className="field input">
							<label htmlFor='replyMessage' className="field-label">
								<TextareaAutosize name="message"
									style={ { maxHeight: 200 } }
									onChange={ this.handleInputChange }
									placeholder='Your Post...'
									value={ this.state.message }
								/>
							</label>
						</div>
						<ul>
							{this.images()}
						</ul>
					</div>
				);

			case 'replyQuoting':
			case 'replyPost':
				return (
					<div className="reply-modal">
						<UserIcon user={ this.currentUser } layout="nostatus" className="user-info" noAction={ true } />
						<div className="field input">
							<span>Post reply to:</span>
							<label htmlFor='replyTitle' className="field-label">
								<input name="title" onChange={ this.handleInputChange } type="text" placeholder='Title' value={ this.state.title }/>
							</label>
						</div>
						<div className="field input">
							<label htmlFor='replyMessage' className="field-label">
								<TextareaAutosize
									name="message"
									onChange={ this.handleInputChange }
									style={{ maxHeight: 200 }}
									placeholder='Your Post...'
									value={ this.state.message }
								/>
							</label>
						</div>
						<ul>
							{this.images()}
						</ul>
					</div>
				);

			case 'editPost':
				return (
					<div className="reply-modal">
						<UserIcon user={ this.currentUser } layout="nostatus" className="user-info" noAction={ true } />
						<div className="field input">
							<label htmlFor='reasonForEditing' className="field-label">
								<input name="reason" onChange={ this.handleInputChange } type="text"  placeholder='Reason for Editing' value={ this.state.reason }/>
							</label>
						</div>
						<div className="field input">
							<label htmlFor='replyMessage' className="field-label">
								<TextareaAutosize
									name="message"
									style={ { maxHeight: 200 } }
									onChange={ this.handleInputChange }
									placeholder='Your Post...'
									value={ this.state.message }
								/>
							</label>
						</div>
						<ul>
							{this.images()}
						</ul>
					</div>
				);

			case 'newMessage':
				return (
					<div className="reply-modal">
						<div className="field">
							{this.recipients()}
							<label htmlFor='replyTo' className="field-label" />
						</div>
						<div className="field input">
							<label htmlFor='replySubject' className="field-label">
								<input name="subject" onChange={ this.handleInputChange } type="text"  placeholder='Subject:' value={ this.state.subject }/>
							</label>
						</div>
						<div className="field input">
							<label htmlFor='replyMessage' className="field-label">
								<TextareaAutosize
									name="message"
									style={ { maxHeight: 200 } }
									onChange={ this.handleInputChange }
									placeholder='Your message...'
									value={ this.state.message }
								/>
							</label>
						</div>
					</div>
				);

			case 'replyMessageQuoting':
			case 'replyMessage':
				return (
					<div className="reply-modal">
						<div className="field">
							{this.recipients()}
							<label htmlFor='replyTo' className="field-label" />
						</div>
						<div className="field input">
							<label htmlFor='replySubject' className="field-label">
								<input name="subject" onChange={ this.handleInputChange } type="text" placeholder='Subject:' readOnly value={ this.state.subject }/>
							</label>
						</div>
						<div className="field input">
							<label htmlFor='replyMessage' className="field-label">
								<TextareaAutosize
									name="message"
									style={ { maxHeight: 200 } }
									onChange={ this.handleInputChange }
									placeholder='Your message...'
									value={ this.state.message }
								/>
							</label>
						</div>
					</div>
				);
		}
	};

	render() {
		if( !this.props.isOpen ) {
			return null;
		}

		let className = ( this.props.loading  ? ' opened' : '' );

		return (
			<div className="modal reply">
				<div className="reply-window" onClick={( e ) => { e.stopPropagation(); }}>
					<header id="headerModal" className="primary">
						<div className="buttons-container leftHeaderIcons">
							<div className="buttons" onClick={ this.hideThisReplyModal }>
								<SvgIcon icon="arrow_back" size="24px"/>
							</div>
						</div>
						<div className="title">
							{this.title()}
						</div>
						{this.actionButtons()}
					</header>
					<section className="reply-content">
						{this.content()}
					</section>
					<div className={ `overlayMask${ className }` } >
						<span className={`globalLoading${ className }`}>Sending...</span>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		isOpen: state.ui.replyModal.opened,
		options: state.ui.replyModal.options,
		loading: state.ui.replyModal.loading,
		responseHash: state.ui.replyModal.responseHash,
		attachments: state.ui.replyModal.attachments,
		attachmentLoading: state.ui.replyModal.attachmentLoading,
		url: state.topifyPresets.forumSite.url,
		ustate: state.ustate,
		forumview: state.forumview,
		meta: state.meta
	};
};

export default connect( mapStateToProps )( ReplyModalComponent );


// WEBPACK FOOTER //
// ./src/components/modals/ReplyModalComponent.js